import * as React from "react";

const MiniPptxFileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M0 17h17v3H4l-4-3Z" fill="#BF360C" />

    <mask id="pptx-mask" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.757 0H3a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V5.243L13.757 0Z"
      />
    </mask>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.757 0H3a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V5.243L13.757 0Z"
      fill="#F2F2F2"
    />

    <path
      d="m13.757 0 .707-.707L14.172-1h-.415v1ZM19 5.243h1v-.415l-.293-.292-.707.707ZM3 1h10.757v-2H3v2Zm0 0v-2a2 2 0 0 0-2 2h2Zm0 19V1H1v19h2Zm0 0H1a2 2 0 0 0 2 2v-2Zm15 0H3v2h15v-2Zm0 0v2a2 2 0 0 0 2-2h-2Zm0-14.757V20h2V5.243h-2Zm1.707-.707L14.464-.707 13.05.707l5.243 5.243 1.414-1.414Z"
      fill="#E64A19"
      mask="url(#pptx-mask)"
    />

    <path
      d="M6.5 4.5h2.5c.8 0 1.5.3 2.1.8s1 1.2 1 2s-.4 1.5-1 2s-1.3.8-2.1.8h-2.5V4.5Zm1.5 1.5v3h1c.5 0 .9-.1 1.2-.4s.5-.6.5-1.1c0-.5-.2-.8-.5-1.1s-.7-.4-1.2-.4h-1Z"
      fill="#E64A19"
    />

    <path fill="#E64A19" d="M0 12h17v5H0z" />

    <path
      d="M4 13.5h.8v1.1h.7c.3 0 .5.1.7.3s.3.4.3.7c0 .3-.1.5-.3.7s-.4.3-.7.3h-.7v.3H4v-2.4Zm.8 1.1h.7c.2 0 .3-.1.4-.2s.1-.2.1-.4-.1-.3-.1-.4-.2-.2-.4-.2h-.7v1.2Z M6.5 13.5h.8v1.1h.7c.3 0 .5.1.7.3s.3.4.3.7c0 .3-.1.5-.3.7s-.4.3-.7.3h-.7v.3h-.8v-2.4Zm.8 1.1h.7c.2 0 .3-.1.4-.2s.1-.2.1-.4-.1-.3-.1-.4-.2-.2-.4-.2h-.7v1.2Z M9 13.5h.8v.3h-.8v2.1H9v-2.1h-.8v-.3H9Z M10.5 13.5h.6l.6.9.6-.9h.6l-.8 1.2.7 1.3h-.6l-.6-1.2-.7 1.1h-.6l.7-1.3Z"
      fill="#fff"
    />
  </svg>
);

export default MiniPptxFileIcon;
